export const FRAMING_HANDLE_WIDTH_PX = 10;
